import { useState, useEffect, useCallback } from "react";

import { DataFilter } from "interfaces";
import DataFilterComponent from "./Data-Filter";
import DataFilterSummary from "./Filter-Summary";

interface Props {
  name?: string;
  columns: string[];
  columnTypes: DataFilter.ColTypes;
  stats?: { [col: string]: DataFilter.Stats };
  onColumnSelect?: (column: string) => any;
  existingFilters?: DataFilter.Filter[];
  onFilterChange?: (filters: DataFilter.Filter[]) => any;
  showFilterHelp?: boolean;
}

const FilterListCreate: React.FC<Props> = ({
  name,
  columns,
  columnTypes,
  stats,
  onColumnSelect,
  existingFilters,
  onFilterChange,
  showFilterHelp = true,
}) => {
  const [filters, setFilters] = useState<DataFilter.Filter[]>(
    existingFilters || []
  );
  const [filterToEdit, setFilterToEdit] = useState<DataFilter.Filter>();
  const [filterToBeAddedAtIndex, setAddFilterIndex] = useState(
    existingFilters?.length || 0
  );

  useEffect(() => {
    if (existingFilters && filters !== existingFilters) {
      setFilters(existingFilters);
      setAddFilterIndex(existingFilters.length);
    }
  }, [filters, existingFilters, setFilters, setAddFilterIndex]);

  const addFilter = useCallback(
    (f: DataFilter.Filter) => {
      let newFilters = [...filters];
      if (filters[filterToBeAddedAtIndex]?.column === f.column) {
        newFilters.splice(filterToBeAddedAtIndex, 1, f);
      } else {
        newFilters.push(f);
      }
      setFilters(newFilters);
      setFilterToEdit(undefined);
      setAddFilterIndex(newFilters.length);
      if (onFilterChange) {
        onFilterChange(newFilters);
      }
    },
    [
      filters,
      setFilters,
      setFilterToEdit,
      filterToBeAddedAtIndex,
      setAddFilterIndex,
      onFilterChange,
    ]
  );

  return (
    <div>
      <DataFilterComponent
        name={name}
        columns={columns}
        onColumnSelect={onColumnSelect}
        stats={stats || {}}
        columnTypes={columnTypes}
        addFilter={addFilter}
        initFilter={filterToEdit}
        showFilterHelp={showFilterHelp}
      />
      <div className="my-1 p-1">
        {filters.length === 0 && <p>No filters selected!!!</p>}
        {filters.map((f, ind) => (
          <p key={ind}>
            <DataFilterSummary
              index={ind + 1}
              type={columnTypes[f.column]}
              filter={f}
              removeFilter={() => {
                const newFilters = filters.filter((_, i) => i !== ind);
                setFilters(newFilters);
                if (onFilterChange) {
                  onFilterChange(newFilters);
                }
              }}
              editFilter={() => {
                setFilterToEdit({ ...filters[ind] });
                setAddFilterIndex(ind);
              }}
            />
          </p>
        ))}
      </div>
    </div>
  );
};

export default FilterListCreate;
